import { useSelector } from 'react-redux';

/**
 * Check if the current logged in user is owner of the current active customer.
 *
 * @returns {boolean} True if owner, false otherwise.
 */
export default () => {
  const customer = useSelector((state) => state.app.customer);
  const customers = useSelector((state) => state.user.customers);

  const activeCustomer = customers?.find((item) => item.id === customer?.id);

  return activeCustomer?.owner || false;
};
